document.addEventListener("DOMContentLoaded", async () => {
  const highlightTextElement = document.querySelector(".highlight-text");
  if (!highlightTextElement) return;

  // Check sessionStorage to see if the animation has already played in this session
  const hasPlayedAnimation = sessionStorage.getItem("hasPlayedAnimation");

  // Check if the page was refreshed
  // this version will be depreciated but still works
  // const isPageReloaded = performance.navigation.type === performance.navigation.TYPE_RELOAD;
  const navigationType = performance.getEntriesByType("navigation")[0]?.type;
  const isPageReloaded = navigationType === "reload";


  // If the animation has already been played in this session and it's not a page refresh, skip the animation
  if (hasPlayedAnimation && !isPageReloaded) {
    highlightTextElement.classList.add("final");
    return;
  }

  // Dynamically import SplitType for animation
  const { default: SplitType } = await import("https://cdn.skypack.dev/split-type@0.3.3");

  // Create GSAP timeline
  const tlthick = gsap.timeline();

  // Split the text
  const splitText = SplitType.create("p.highlight-text", { types: "words" });
  const splitWords = splitText.words;

  /* Observer listens for when it's in view, then runs */
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // Animate the highlight text
        tlthick.fromTo(
          ".highlight-text",
          { opacity: 0 },
          { opacity: 1, duration: 1, ease: "linear" }
        );

        // Function to animate the words
        splitWords.forEach(function (item, index) {
          const width = item.offsetWidth;
          const dur = width / 100 / 4;

          // Animate each word
          tlthick.fromTo(
            item,
            { backgroundPosition: "100%" },
            { backgroundPosition: "0", duration: dur, ease: "linear", stagger: index + 1 }
          );
        });

        // Custom letter animation for .text
        const text = document.querySelector(".text");
        if (text) {
          const splitTextIntoLetters = (el) => {
            el.innerHTML = el.textContent.replace(/(\S*)/g, (m) => {
              return `<div class="word">${m.replace(/(-|#|@)?\S(-|#|@)?/g, "<div class='letter'>$&</div>")}</div>`;
            });
            return el;
          };
          splitTextIntoLetters(text);

          tlthick.fromTo(
            ".letter",
            { x: -500, opacity: 0 },
            { x: 0, opacity: 1, duration: 0.3, stagger: 0.05, ease: "power3.out", delay: 1 },
            "-=1.4"
          );
        }

        // Animate the rotate buttons
        tlthick.fromTo(
          ".rotate",
          { x: -500, opacity: 0 },
          { x: 0, opacity: 1, duration: 0.4, stagger: 0.3, ease: "power3.out", delay: 1.2 },
          "-=1"
        );


        // Animate the h3 elements with custom classes
        tlthick.fromTo(
          ".kg-woods-h2, .kg-woods-h3",
          {
            opacity: 0,
          },
          {
            opacity: 1,
            stagger: 0.2,
            duration: 1,
            ease: "linear",
            delay: "-=0.5",
          }
        );


        tlthick.fromTo(
          ".kg-subhead1",
          {
            opacity: 0,
          },
          {
            opacity: 1,
            duration: 1, // Adjust duration as needed
            ease: "linear",
            delay: "-=0.5",
          }
        );


        observer.unobserve(entry.target);
        sessionStorage.setItem("hasPlayedAnimation", "true");

        tlthick.eventCallback("onComplete", () => {
          highlightTextElement.classList.add("final");
        });
      }
    });
  });

  observer.observe(highlightTextElement);
});

/* start code added by gagan */
document.addEventListener("DOMContentLoaded", function () {
  console.log("sdaasdasd");
  setTimeout(function () {
    const url = window.location.href;
    const productIdentifiers = [
      "formula-fire-pro-right-hand",
      "formula-fire-pro-left-hand",
    ];
    const loftParam = "attribute_loft=4";

    const isProductMatch = productIdentifiers.some((identifier) =>
      url.includes(identifier)
    );

    if (isProductMatch && url.includes(loftParam)) {
      // Step 2: Find the select element for Loft
      const loftSelect = document.querySelector(
        'select[name="properties[Loft]"]'
      );
      if (loftSelect) {
        for (let option of loftSelect.options) {
          if (option.value === "10.5°") {
            option.selected = true;
            loftSelect.dispatchEvent(new Event("change"));
            break;
          }
        }
      }
    }

    const url1 = window.location.href;
    const productIdentifiers1 = ["formula-fire-x-left-hand"];
    const loftParam1 = "attribute_length=2";

    const isProductMatch1 = productIdentifiers1.some((identifier) =>
      url1.includes(identifier)
    );

    if (isProductMatch1 && url1.includes(loftParam1)) {
      const shaftFlexSelects = document.querySelectorAll(
        'select[name="properties[Shaft Flex]"]'
      );

      if (shaftFlexSelects.length > 1) {
        const secondShaftFlexSelect = shaftFlexSelects[1]; // The second select element

        console.log("Second Shaft Flex dropdown found:", secondShaftFlexSelect);

        let isOptionFound = false;
        for (let option of secondShaftFlexSelect.options) {
          console.log(`Option value: ${option.value}`);
          if (option.value === "44.5") {
            option.selected = true;
            secondShaftFlexSelect.dispatchEvent(new Event("change"));
            isOptionFound = true;
            console.log("Option 44.5 selected and change event dispatched.");
            break;
          }
        }
        if (!isOptionFound) {
          console.warn(
            "Desired option (44.5) not found in the second dropdown."
          );
        }
      } else {
        console.warn("Second Shaft Flex dropdown not found.");
      }
    }

    const url2 = window.location.href;
    const productIdentifiers12 = ["formula-fire-x-left-hand"];
    const loftParam12 = "attribute_length=4";

    const isProductMatch12 = productIdentifiers12.some((identifier) =>
      url2.includes(identifier)
    );

    if (isProductMatch12 && url2.includes(loftParam12)) {
      const shaftFlexSelects2 = document.querySelectorAll(
        'select[name="properties[Shaft Flex]"]'
      );

      if (shaftFlexSelects2.length > 1) {
        const secondShaftFlexSelect2 = shaftFlexSelects2[1]; // The second select element

        console.log(
          "Second Shaft Flex dropdown found:",
          secondShaftFlexSelect2
        );

        let isOptionFound2 = false;
        for (let option2 of secondShaftFlexSelect2.options) {
          console.log(`Option value: ${option2.value}`);
          if (option2.value === "45.5 (Standard Length)") {
            option2.selected = true;
            secondShaftFlexSelect2.dispatchEvent(new Event("change"));
            isOptionFound2 = true;
            console.log(
              "Option 45.5 (Standard Length) selected and change event dispatched."
            );
            break;
          }
        }

        if (!isOptionFound2) {
          console.warn(
            "Desired option (44.5) not found in the second dropdown."
          );
        }
      } else {
        console.warn("Second Shaft Flex dropdown not found.");
      }
    }
    const url3 = window.location.href;
    const productIdentifiers13 = ["formula-fire-x-left-hand"];
    const loftParam13 = "attribute_grip_size=2";

    const isProductMatch13 = productIdentifiers13.some((identifier) =>
      url3.includes(identifier)
    );

    if (isProductMatch13 && url3.includes(loftParam13)) {
      const shaftFlexSelects3 = document.querySelector(
        'select[name="properties[Grip Size]"]'
      );
      if (shaftFlexSelects3) {
        for (let option of shaftFlexSelects3.options) {
          if (option.value === "Medium") {
            option.selected = true;
            shaftFlexSelects3.dispatchEvent(new Event("change"));
            break;
          }
        }
      }
    }
  }, 1000);
  /* end start code added by gagan */
});

// back to normal

/* start code added by gagan */
document.addEventListener("DOMContentLoaded", function () {
  console.log("sdaasdasd");
  setTimeout(function () {
    const url = window.location.href;
    const productIdentifiers = [
      "formula-fire-pro-right-hand",
      "formula-fire-pro-left-hand",
    ];
    const loftParam = "attribute_loft=4";

    const isProductMatch = productIdentifiers.some((identifier) =>
      url.includes(identifier)
    );

    if (isProductMatch && url.includes(loftParam)) {
      // Step 2: Find the select element for Loft
      const loftSelect = document.querySelector(
        'select[name="properties[Loft]"]'
      );
      if (loftSelect) {
        for (let option of loftSelect.options) {
          if (option.value === "10.5°") {
            option.selected = true;
            loftSelect.dispatchEvent(new Event("change"));
            break;
          }
        }
      }
    }

    const url1 = window.location.href;
    const productIdentifiers1 = ["formula-fire-x-left-hand"];
    const loftParam1 = "attribute_length=2";

    const isProductMatch1 = productIdentifiers1.some((identifier) =>
      url1.includes(identifier)
    );

    if (isProductMatch1 && url1.includes(loftParam1)) {
      const shaftFlexSelects = document.querySelectorAll(
        'select[name="properties[Shaft Flex]"]'
      );

      if (shaftFlexSelects.length > 1) {
        const secondShaftFlexSelect = shaftFlexSelects[1]; // The second select element

        console.log("Second Shaft Flex dropdown found:", secondShaftFlexSelect);

        let isOptionFound = false;
        for (let option of secondShaftFlexSelect.options) {
          console.log(`Option value: ${option.value}`);
          if (option.value === "44.5") {
            option.selected = true;
            secondShaftFlexSelect.dispatchEvent(new Event("change"));
            isOptionFound = true;
            console.log("Option 44.5 selected and change event dispatched.");
            break;
          }
        }
        if (!isOptionFound) {
          console.warn(
            "Desired option (44.5) not found in the second dropdown."
          );
        }
      } else {
        console.warn("Second Shaft Flex dropdown not found.");
      }
    }

    const url2 = window.location.href;
    const productIdentifiers12 = ["formula-fire-x-left-hand"];
    const loftParam12 = "attribute_length=4";

    const isProductMatch12 = productIdentifiers12.some((identifier) =>
      url2.includes(identifier)
    );

    if (isProductMatch12 && url2.includes(loftParam12)) {
      const shaftFlexSelects2 = document.querySelectorAll(
        'select[name="properties[Shaft Flex]"]'
      );

      if (shaftFlexSelects2.length > 1) {
        const secondShaftFlexSelect2 = shaftFlexSelects2[1]; // The second select element

        console.log(
          "Second Shaft Flex dropdown found:",
          secondShaftFlexSelect2
        );

        let isOptionFound2 = false;
        for (let option2 of secondShaftFlexSelect2.options) {
          console.log(`Option value: ${option2.value}`);
          if (option2.value === "45.5 (Standard Length)") {
            option2.selected = true;
            secondShaftFlexSelect2.dispatchEvent(new Event("change"));
            isOptionFound2 = true;
            console.log(
              "Option 45.5 (Standard Length) selected and change event dispatched."
            );
            break;
          }
        }

        if (!isOptionFound2) {
          console.warn(
            "Desired option (44.5) not found in the second dropdown."
          );
        }
      } else {
        console.warn("Second Shaft Flex dropdown not found.");
      }
    }
    const url3 = window.location.href;
    const productIdentifiers13 = ["formula-fire-x-left-hand"];
    const loftParam13 = "attribute_grip_size=2";

    const isProductMatch13 = productIdentifiers13.some((identifier) =>
      url3.includes(identifier)
    );

    if (isProductMatch13 && url3.includes(loftParam13)) {
      const shaftFlexSelects3 = document.querySelector(
        'select[name="properties[Grip Size]"]'
      );
      if (shaftFlexSelects3) {
        for (let option of shaftFlexSelects3.options) {
          if (option.value === "Medium") {
            option.selected = true;
            shaftFlexSelects3.dispatchEvent(new Event("change"));
            break;
          }
        }
      }
    }
  }, 1000);
  /* end start code added by gagan */
});

